module.exports = __webpack_public_path__ + "static/media/44.85e90c43.jpg";